<ng-container *ngIf="TREE_DATA.length">
    <div class="row justify-content-center" [hidden]="inSearchableMode" *ngIf="hasSelectAll">
        <div class="col-12">
            <div class="select-all" [formGroup]="formGroup">
                <mat-checkbox [formControlName]="formControlName" (change)="selectAllItems()">
                    {{'notifications.Select All' | translate }}
                </mat-checkbox>
            </div>
        </div>
    </div>
    <mat-tree class="mat-tree-with-img" [dataSource]="dataSource" [treeControl]="treeControl"
        [ngClass]="{'tree-view': isView, 'has-error': hasError()}">

        <mat-tree-node class="has-parent" [ngClass]="'level-' + node.level" [style.display]="
        (isView && !node.is_checked)
        ||
        (searchText && hideLeafNode(node) && !showParentNode(node))
        ? 'none' : 'flex'" *matTreeNodeDef="let node; let i = index" matTreeNodeToggle matTreeNodePadding>

            <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
                (change)="todoLeafItemSelectionToggle(node); selectedItem($event);">

                <div class="name-with-image mb-0">
                    <div class="image-square" [ngClass]="smallImage ? 'small-square' : ''">
                        <img *ngIf="node.image" [src]="node.image" (error)='node.image = ""'>
                        <span *ngIf="!node.image">{{ node.name | shortName }}</span>
                    </div>
                    <div class="name">
                        <h5 class="font-18 fontRegular">{{node.name}}</h5>
                        <h5 class="font-18 fontRegular">{{node.offer_type?.name}}</h5>
                    </div>
                </div>
            </mat-checkbox>
        </mat-tree-node>

        <mat-tree-node class="parent justify-content-between" *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding [ngClass]="'level-' + node.level"
            [style.display]="hideParentNode(node) && hideLeafNode(node) ? 'none' : 'flex'"
            [class.active]="treeControl.isExpanded(node)">

            <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
                (change)="todoItemSelectionToggle(node); selectedItem($event);">
                <div class="name-with-image mb-0">
                    <div class="image-square">
                        <img *ngIf="node.logo || node.image" [src]="node.logo || node.image" (error)='node.logo = ""'>
                        <span *ngIf="!(node.logo || node.image)">{{ node.name | shortName }}</span>
                    </div>
                    <div class="name">
                        <h5 class="font-18 fontRegular mb-2" style="max-width: 15vw !important;">{{node.name}}</h5>
                        <h5 class="font-14 fontRegular">
                            {{getSelectedChildCount(node)}} <span class="grey-color">
                                <ng-container *ngIf="type == 'company'">
                                    {{ 'vendorOffers.selected departments from' | translate }}
                                </ng-container>
                                <ng-container *ngIf="type != 'company'">
                                    {{ 'newsletter.selected offer from' | translate }}
                                </ng-container>
                            </span> {{node.child.length}}
                        </h5>
                    </div>
                </div>
            </mat-checkbox>


            <button mat-icon-button matTreeNodeToggle type="button">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_less' : 'expand_more'}}
                </mat-icon>
            </button>

        </mat-tree-node>

    </mat-tree>
</ng-container>
<p class="has-error" *ngIf="hasError()">{{"forms.Required" | translate}}</p>